import dayjs from "dayjs";
dayjs.locale("ja");

export function fromMonthly(date) {
  return dayjs(date).format("YYYY-MM-DD 00:00:00");
}

export function toMonthly(date) {
  return dayjs(date).format("YYYY-MM-DD 23:59:59");
}

export function fromDaily(date) {
  return dayjs(date).format("YYYY-MM-DD 00:00:00");
}

export function toDaily(date) {
  return dayjs(date).format("YYYY-MM-DD 23:59:59");
}

export function fromHourly(date) {
  return dayjs(date).format("YYYY-MM-DD HH:00:00");
}

export function toHourly(date) {
  return dayjs(date).format("YYYY-MM-DD HH:59:59");
}

export function fromDetail(date) {
  return dayjs(date).format("YYYY-MM-DD HH:mm:00");
}

export function toDetail(date, interval) {
  return dayjs(date)
    .add(interval, "minute")
    .subtract(1, "second")
    .format("YYYY-MM-DD HH:mm:ss");
}
